import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import RegisterPage from "@/pages/RegisterPage";
import LoginPage from "@/pages/LoginPage";
import PasswordReset from "@/pages/PasswordReset";
import ApplicationPage from "@/pages/ApplicationPage";
import ApplicationSuccess from "@/pages/ApplicationSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboardNew";
import WaitlistManagement from "@/pages/WaitlistManagement";
import GradeManagement from "@/pages/GradeManagement";
import EnrolledDashboard from "@/pages/EnrolledDashboard";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<PasswordReset />} />
            <Route 
              path="/application" 
              element={user && user.role === "parent" ? <ApplicationPage /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/application-success/:applicationId" 
              element={user && user.role === "parent" ? <ApplicationSuccess /> : <Navigate to="/login" />} 
            />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={user && user.role === "admin" ? <AdminDashboard /> : <Navigate to="/admin" />} 
            />
            <Route 
              path="/admin/waitlist-management" 
              element={user && user.role === "admin" ? <WaitlistManagement /> : <Navigate to="/admin" />} 
            />
            <Route 
              path="/admin/grade-management" 
              element={user && user.role === "admin" ? <GradeManagement /> : <Navigate to="/admin" />} 
            />
            <Route 
              path="/admin/enrolled" 
              element={user && user.role === "admin" ? <EnrolledDashboard /> : <Navigate to="/admin" />} 
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthContext.Provider>
  );
}

import React from 'react';
export default App;